import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item"];
import React from 'react';
import { Highlight } from '../Highlight/Highlight';
import { DescDelimiter } from './DescDelimiter';
import { Row } from './Row';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function NpmRow(_ref) {
  var _item$title;
  var item = _ref.item,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var titleField = (_item$title = item.title) !== null && _item$title !== void 0 ? _item$title : item.name;
  var title = /*#__PURE__*/_jsx(Highlight, {
    text: titleField
  });
  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [item.version ? /*#__PURE__*/_jsx(Highlight, {
      text: item.version.toString()
    }) : null, item.version && item.description ? /*#__PURE__*/_jsx(DescDelimiter, {}) : null, /*#__PURE__*/_jsx(Highlight, {
      text: item.description
    })]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    title: title,
    description: description,
    item: item
  }, otherProps));
}
// #sourceMappingURL=NpmRow.js.map